<template>
  <Row>
    <Col span="24">
    <Card>
      <p slot="title">研究中心列表</p>
      <span slot="extra">
        <Select v-model="status" style="width:120px" @on-change="fetchData" placeholder="请选择状态" clearable>
          <Option v-for="(status,key) in statuses" :value="key" :key="key">{{ status }}</Option>
        </Select>
        <Input v-model="queryStr" placeholder="请输入关键词查询" @on-change="fetchData" style="width: 300px"></Input>
        <Button type="success" @click="showAdd = true"><Icon type="plus"></Icon> 添加</Button>
      </span>
      <Table stripe :columns="attributes" :data="sites" v-if="sites"></Table>
      <pagination v-bind:meta="pageMeta" name="pagination" @refresh="fetchData"></pagination>
    </Card>
    <Modal
        v-model="showAdd"
        title="添加研究中心"
        :styles="{bottom:'0px'}" >
        <add-site ref="addSite" @refresh="refresh"></add-site>
        <div slot="footer" v-show="false"></div>
    </Modal>
    <Modal
        v-model="showEdit"
        title="编辑研究中心信息"
        :styles="{bottom:'0px'}" >
        <edit-site ref="editSite" :meta="meta" @refresh="refresh"></edit-site>
        <div slot="footer" v-show="false"></div>
    </Modal>
    </Col>
  </Row>
</template>

<script>
import { ListSites, DeleteSite } from '@/api/site'
import AddSite from '@/components/site/AddSite'
import EditSite from '@/components/site/EditSite'
import Pagination from '@/components/share/Pagination'

export default {
  name: 'list-sites',
  data: function () {
    return {
      sites: [],
      queryStr: '',
      meta: '',
      showAdd: false,
      showEdit: false,
      pageMeta: {},
      status: '1',
      statuses: {
        '1': '激活',
        '0': '禁用'
      },
      attributes: [{
        title: '中心编号',
        key: 'invid'
      },
      {
        title: '单位名称',
        key: 'site_name'
      },
      {
        title: '计划样本量',
        key: 'number'
      },
      {
        title: '状态',
        key: 'statusText'
      },
      {
        title: '操作',
        key: 'action',
        width: 120,
        render: (h, params) => {
          const icon = params.row.status === 1 ? 'ios-trash' : 'ios-refresh'
          return h('div', [
            h('Button', {
              props: {
                type: 'text',
                size: 'small',
                icon: 'ios-create-outline'
              },
              on: {
                click: () => {
                  this.edit(params.row.id)
                }
              }
            }),
            h('Button', {
              props: {
                type: 'text',
                size: 'small',
                icon: icon
              },
              on: {
                click: () => {
                  this.remove(params.row.id)
                }
              }
            })
          ])
        }
      }]
    }
  },
  components: {
    'pagination': Pagination,
    'add-site': AddSite,
    'edit-site': EditSite
  },
  created: function () {
    this.fetchData()
  },
  methods: {
    fetchData: function (page = 1) {
      var query = this.$router.currentRoute.query
      query['page'] = page
      query['SiteSearch[status]'] = this.status
      query['SiteSearch[studyid]'] = this.$route.params.id
      query['queryStr'] = this.queryStr
      ListSites(query).then(async res => {
        this.sites = res.items
        this.pageMeta = res._meta
      })
    },
    refresh: function () {
      this.fetchData()
      this.showAdd = false
      this.showEdit = false
    },
    edit: function (id) {
      this.meta = id
      this.$refs.editSite.init(id)
      this.showEdit = true
    },
    remove: function (id) {
      DeleteSite(id).then(async res => {
        this.refresh()
      })
    }
  }
}
</script>
